import { type UseQueryOptions, useQuery } from '@lumapps/base-api/react-query';

import { type GetDocumentPermissionsParams, documentsQueryKeys, getDocumentPermissions } from '../api';

/**
 * A hook to fetch the permissions for a document
 */
export const useGetDocumentPermissions = (
    { docPath, searchParameters }: GetDocumentPermissionsParams,
    options?: UseQueryOptions,
) => {
    return useQuery({
        ...options,
        queryKey: documentsQueryKeys.getPermissions({ docPath, searchParameters }),
        queryFn: async ({ signal }) => getDocumentPermissions({ docPath, searchParameters }, signal),
    });
};
